import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { useRef, useEffect } from "react";

const CalendarComponent = ({
  goToPreviousMonth,
  goToNextMonth,
  currentMonth,
  renderCalendar,
  setShowCalendar,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [setShowCalendar]);

  return (
    <div ref={ref} className="mt-2 rounded-[15px] border-[1px] border-[#7876A1] p-[19px] overflow-hidden">

      {/* Header */}
      <div className="flex items-center justify-center mb-2">
        <button type="button" className="p-2 text-lg" onClick={goToPreviousMonth}>
          <IoChevronBack />
        </button>
        <div className="font-semibold text-[#4743BF]">
          {currentMonth.toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
          })}
        </div>
        <button type="button" className="p-2 text-lg" onClick={goToNextMonth}>
          <IoChevronForward />
        </button>
      </div>

      {/* Days of week */}
      <div className="grid grid-cols-7 gap-[3px] text-[12px] text-[#4743BF] mb-[3px]">
        <div className="text-center">Su</div>
        <div className="text-center">Mo</div>
        <div className="text-center">Tu</div>
        <div className="text-center">We</div>
        <div className="text-center">Th</div>
        <div className="text-center">Fr</div>
        <div className="text-center">Sa</div>
      </div>

      {/* Calendar Days - ALWAYS 6 ROWS FIXED */}
      <div className="grid grid-cols-7 grid-rows-6 gap-[3px] font-[700] text-[12px] text-[#211F59]">
        {renderCalendar()}
      </div>
    </div>
  );
};

export default CalendarComponent;
